import React from 'react';
import moment from 'moment';

import { DescriptionText } from 'components';

import HeaderText from './HeaderText';

type DateSectionProps = {
  startDate: string;
  endDate: string;
  dataCy?: string;
};

const DateSection: React.FC<DateSectionProps> = ({
  startDate,
  endDate,
  dataCy,
}) => {
  const timeRangeString = `${moment(startDate).format('h:mma')}-${moment(
    endDate,
  ).format('h:mma')}`;
  const dateString = moment(startDate).format('dddd MMMM D');

  return (
    <div data-cy={dataCy}>
      <HeaderText>{timeRangeString}</HeaderText>
      <DescriptionText>{dateString}</DescriptionText>
    </div>
  );
};

export default DateSection;
